import { useState } from 'react';
import { Sheet } from './Sheet';

/** Name a new board or rename one. */
export function BoardNameSheet({
  initial = '',
  title,
  onSave,
  onClose,
}: {
  initial?: string;
  title: string;
  onSave: (name: string) => void;
  onClose: () => void;
}) {
  const [name, setName] = useState(initial);
  return (
    <Sheet open onClose={onClose} onSubmit={() => name.trim() && onSave(name.trim())} labelledBy="boardNameTitle">
      <h2 id="boardNameTitle">{title}</h2>
      <div className="field">
        <label htmlFor="b-name">Name</label>
        <input
          id="b-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="z. B. Herbst, Urlaub, Geburtstag"
          maxLength={60}
          autoComplete="off"
          data-autofocus
        />
      </div>
      <div className="sheet-actions">
        <div className="right">
          <button type="button" className="btn" onClick={onClose}>
            Abbrechen
          </button>
          <button type="submit" className="btn ink" disabled={!name.trim()}>
            Speichern
          </button>
        </div>
      </div>
    </Sheet>
  );
}
